export default {"src":"/_next/static/media/bird.cf54b8eb.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};